// Client Book: the routes and the sidebar rows of `wealth.crm.client-book` (ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

// The Other tab of the client record: each field that has no other tab.
const OtherTabSlot = lazy(() =>
    import('./client-book.slots').then((m) => ({ default: m.OtherTabSlot })),
);

export default defineWebFeature({
    id: 'wealth.crm.client-book',
    routes: [
        {
            frontend: 'desk',
            path: 'client-book',
            lazy: () => import('@/pages/desk/client-book/page'),
        },
        {
            frontend: 'desk',
            path: 'client-book/:clientId',
            lazy: () => import('@/pages/desk/client-book/client/page'),
        },
        {
            frontend: 'desk',
            path: 'client-book/:clientId/holdings',
            lazy: () => import('@/components/client-book/ClientHoldingsPage'),
        },
        {
            frontend: 'ops',
            path: 'client-book',
            lazy: () => import('@/pages/ops/client-book/page'),
        },
        {
            frontend: 'ops',
            path: 'client-book/:clientId',
            lazy: () => import('@/pages/ops/client-book/client/page'),
        },
        {
            frontend: 'ops',
            path: 'client-book/:clientId/holdings',
            lazy: () => import('@/components/client-book/ClientHoldingsPage'),
        },
        {
            frontend: 'comply',
            path: 'client-book',
            lazy: () => import('@/pages/comply/client-book/page'),
        },
        {
            frontend: 'comply',
            path: 'client-book/:clientId',
            lazy: () => import('@/pages/comply/client-book/client/page'),
        },
        {
            frontend: 'comply',
            path: 'client-book/:clientId/holdings',
            lazy: () => import('@/components/client-book/ClientHoldingsPage'),
        },
        {
            frontend: 'view',
            path: 'client-book',
            lazy: () => import('@/pages/view/client-book/page'),
        },
        {
            frontend: 'view',
            path: 'client-book/:clientId',
            lazy: () => import('@/pages/view/client-book/client/page'),
        },
        {
            frontend: 'view',
            path: 'client-book/:clientId/holdings',
            lazy: () => import('@/components/client-book/ClientHoldingsPage'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'client-book',
            label: 'Client Book',
            href: '/comply/client-book',
            icon: 'Users',
            group: 'clients-kyc',
            order: 350,
            wip: true,
        },
        {
            frontend: 'desk',
            key: 'client-book',
            label: 'Client Book',
            href: '/desk/client-book',
            icon: 'Users',
            group: 'septima-crm',
            order: 220,
        },
        {
            frontend: 'ops',
            key: 'client-book',
            label: 'Client Book',
            href: '/ops/client-book',
            icon: 'Users',
            group: 'client-operations',
            order: 420,
        },
        {
            frontend: 'view',
            key: 'client-book',
            label: 'Client Book',
            href: '/view/client-book',
            icon: 'Users',
            group: 'clients-risk',
            order: 410,
        },
    ],
    slots: {
        'client.detail.tabs': [
            { key: 'other', order: 30, label: 'Other', Component: OtherTabSlot },
        ],
    },
});
